import { styled } from '@linaria/react'

const createRotateKeyframes = (
  stage1Deg: number,
  stage2Deg: number,
  stage3Deg: number,
  finalDeg: number
) => `
  /* Stage 1: Initial position - hold */
  0%,
  28% {
    transform: rotate(${stage1Deg}deg);
  }
  /* Transition to Stage 2 (clockwise) - smooth transition like 3->1 */
  28%,
  30% {
    transform: rotate(${stage2Deg}deg);
  }
  /* Stage 2: Intermediate position - hold */
  30%,
  58% {
    transform: rotate(${stage2Deg}deg);
  }
  /* Transition to Stage 3 (clockwise) - smooth transition like 3->1 */
  58%,
  60% {
    transform: rotate(${stage3Deg}deg);
  }
  /* Stage 3: Final position - hold */
  60%,
  99% {
    transform: rotate(${stage3Deg}deg);
  }
  /* Transition back to Stage 1 (counter-clockwise) - already smooth */
  99%,
  100% {
    transform: rotate(${finalDeg}deg);
  }
`

export const VoiceSearchLoaderProSC = styled.div`
  position: relative;
  width: 189px;
  height: 189px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 100%;
    height: 100%;
  }

  svg path:nth-of-type(2) {
    transform-origin: 94.5px 94.5px;
    animation: rotateBackgroundRing1 2s cubic-bezier(0, 0.07, 0.32, 1) infinite;
  }

  svg path:nth-of-type(3) {
    transform-origin: 94.5px 94.5px;
    animation: rotateBackgroundRing2 2s cubic-bezier(0, 0.07, 0.32, 1) infinite;
  }

  svg path:first-of-type {
    transform-origin: 94.5px 94.5px;
    animation: rotateTopRing 2s cubic-bezier(0, 0.07, 0.32, 1) infinite;
  }

  @keyframes rotateBackgroundRing1 {
    ${createRotateKeyframes(0, 90, 240, 360)}
  }

  @keyframes rotateBackgroundRing2 {
    ${createRotateKeyframes(0, 100, 200, 360)}
  }

  @keyframes rotateTopRing {
    ${createRotateKeyframes(0, 90, 140, 0)}
  }
`
